import Home from '../views/Home.vue'
import overview from "../views/nurse/overview"
import inventory from "../views/nurse/inventory"
import inbound from "../views/nurse/Inbound"
import offer from "../views/nurse/offer"
import outbound from "../views/nurse/outbound"
import payments from "../views/nurse/payments"
import warehouse from "../views/nurse/warehouse"
import Invitations from "../views/nurse/invitations"
import account from "../views/public/account"
import bank from "../views/public/bank"
import password from "../views/public/password"
import mixedPackageClaim from "../views/mixedPackageClaim"

let nurseRoutes = [
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-home',
        leaf: true,//只有一个节点
        children: [
            {path: '/overview', component: overview, name: 'Home'}
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-file-text-o',
        leaf: true,//只有一个节点
        children: [
            {path: '/offer', component: offer, name: 'Offers'}
        ]
    },  {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-inbox',
        leaf: true,//只有一个节点
        children: [
            {path: '/inbound', component: inbound, name: 'Inbound'}
        ]
    },{
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-product-hunt',
        leaf: true,//只有一个节点
        children: [
            {path: '/inventory', component: inventory, name: 'Inventory'}
        ]
    }, {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-outdent',
        leaf: true,//只有一个节点
        children: [
            {path: '/outbound', component: outbound, name: 'Outbound'}
        ]
    }, {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-credit-card',
        leaf: true,//只有一个节点
        children: [
            {path: '/payments', component: payments, name: 'Payments'}
        ]
    }, 
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-cubes',
        leaf: true,
        children: [
            {path: '/mixedPackageClaim', component: mixedPackageClaim, name: 'Mixed Claim'}
        ]
    }, 
    {
        path: '/',
        component: Home,
        name: 'Settings',
        iconCls: 'fa fa-cog',
        children: [
            {path: '/account',iconCls: 'fa fa-user', component: account, name: 'Account'},
            {path: '/password',iconCls: 'fa fa-key', component: password, name: 'Password'},
            {path: '/bank', iconCls: 'fa fa-credit-card-alt',component: bank, name: 'Bank'},
            {path: '/selfStorage',iconCls: 'fa fa-university', component: warehouse, name: 'Self Storage'},
            {path: '/invitations',iconCls: 'fa fa-handshake-o', component: Invitations, name: 'Invitations'}
        ]
    }];

export default nurseRoutes;





// WEBPACK FOOTER //
// ./src/router/nurseRouter.js